import { TransitionFunction } from 'react';
import { BatchUploadType, ClaimDataEntriesFragmentFragment, ClaimFragmentFragment, InvoiceStatus } from '../api/gql';
import { theme } from '../style/theme';
import { getPriceWithCurrencyString } from './currencies';
import { formatDate } from './format';
import { fromCentesimal } from './transform';

export const getClaimStateProperties = (state: InvoiceStatus, invoiceId: string, batchId?: string) => {
  if (batchId && state === InvoiceStatus.AwaitingPayment) {
    return {
      transKey: 'state.paymentExpected',
      color: theme.palette.warning.main,
      route: `/upload/batch/${batchId}/billing`,
    };
  }

  const map: Record<InvoiceStatus, { transKey: string; color: string; route: string }> = {
    [InvoiceStatus.Processing]: {
      transKey: 'state.processing',
      color: theme.palette.grey['700'],
      route: ``,
    },
    [InvoiceStatus.MissingRequiredData]: {
      transKey: 'state.processing',
      color: theme.palette.grey['700'],
      route: ``,
    },
    [InvoiceStatus.AwaitingVerification]: {
      transKey: 'state.awaitingVerification',
      color: theme.palette.info.main,
      route: ``,
    },
    [InvoiceStatus.AwaitingPayment]: {
      transKey: 'state.paymentExpected',
      color: theme.palette.warning.main,
      route: ``,
    },
    [InvoiceStatus.Settled]: {
      transKey: 'state.paid',
      color: theme.palette.success.main,
      route: `/claim/${invoiceId}`,
    },
    [InvoiceStatus.Reminding]: {
      transKey: 'state.reminding',
      color: theme.palette.warning.main,
      route: `/claim/${invoiceId}`,
    },
    [InvoiceStatus.Complete]: {
      transKey: 'state.completed',
      color: theme.palette.error.main,
      route: `/claim/${invoiceId}`,
    },
    [InvoiceStatus.Archived]: {
      transKey: 'state.archived',
      color: theme.palette.grey['400'],
      route: `/claim/${invoiceId}`,
    },
  };

  return map[state];
};

export function flattenObject(obj: Record<string, any>, parentKey = ''): Record<string, any> {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
        const nestedObj = flattenObject(obj[key], fullKey);
        return { ...acc, ...nestedObj };
      } else {
        acc[fullKey] = obj[key];
        return acc;
      }
    },
    {} as Record<string, any>,
  );
}
